exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_materialUIIcon__PT3Bb{width:1.5rem!important;height:1.5rem!important;min-width:1.5rem!important;line-height:1.5rem!important;padding:0!important;opacity:.7}.style_materialUIIcon__PT3Bb span{padding:0!important}.style_materialUIIcon__PT3Bb:hover{background-color:#fff!important;opacity:1}.style_imageIcon__2Bet0{width:1.5rem;height:1.5rem;opacity:.7}.style_imageIcon__2Bet0:hover{opacity:1}.style_fontAwesomeIcon__24Xxz{opacity:.7}.style_fontAwesomeIcon__24Xxz:hover{opacity:1}", ""]);

// exports
exports.locals = {
	"materialUIIcon": "style_materialUIIcon__PT3Bb",
	"materialUiIcon": "style_materialUIIcon__PT3Bb",
	"imageIcon": "style_imageIcon__2Bet0",
	"fontAwesomeIcon": "style_fontAwesomeIcon__24Xxz"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/IconButton/style.less
// module id = 1537
// module chunks = 8